import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { scrollToForm } from '../utils/scrollToForm';
const navLinks = [{
  name: 'Video',
  href: '/#vsl'
}, {
  name: 'Diagnóstico',
  href: '/#calificar'
}, {
  name: 'Resultados',
  href: '/#resultados'
}];
export function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-black/85 backdrop-blur-xl border-b border-white/10" data-id="element-62" data-mp="4kgbzdy7i7tc">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-63" data-mp="kocdqqsjc04">
        <div className="flex justify-between items-center h-[68px]" data-id="element-64" data-mp="ejean9pcjhq2">
          {/* Logo */}
          <a href="/" className="flex flex-col items-center leading-none shrink-0" data-id="element-65" data-mp="eh1labh9e52z">
            <span className="text-xl font-normal tracking-[0.4em] text-white pl-[0.4em]" data-id="element-66" data-mp="1py1kzs5xrm71">
              VANTIX
            </span>
            <span className="text-[9px] font-medium tracking-[0.3em] text-white/80 border-t border-gold pt-1.5 mt-1.5 w-full text-center pl-[0.3em]" data-id="element-67" data-mp="1kyomga5pcqom">
              CREDIT SOLUTIONS
            </span>
          </a>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-9 absolute left-1/2 -translate-x-1/2" data-id="element-68" data-mp="epdok0kjl7xg">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-[13px] font-medium tracking-wide text-white/80 hover:text-white transition-colors duration-200" data-id="element-69" data-mp="om09epcvbyzh">
                {link.name}
              </a>)}
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center" data-id="element-70" data-mp="ukxq5z7c5bk">
            <a href="/#calificar" onClick={scrollToForm} className="bg-gold hover:bg-gold-light text-black font-semibold text-[13px] tracking-wide px-5 py-2.5 rounded-lg transition-colors duration-200" data-id="element-71" data-mp="5ne7x9dfw5v1">
              Agendar consulta
            </a>
          </div>

          {/* Mobile menu button */}
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden text-white p-1" aria-label={isMobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={isMobileMenuOpen} data-id="element-72" data-mp="3196ryxzvfggw">
            {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-73" data-mp="3642wuyq7hybf" /> : <Menu className="h-6 w-6" data-id="element-74" data-mp="2idgof6caic0w" />}
          </button>
        </div>
      </div>

      {/* Mobile nav */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-black/95 backdrop-blur-xl border-t border-white/10" data-id="element-75" data-mp="2salf9jh2yvo1">
          <div className="px-6 py-4 flex flex-col" data-id="element-76" data-mp="2naz0v6pin9dn">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-base font-medium text-white/80 hover:text-white transition-colors border-b border-white/10 py-4" data-id="element-77" data-mp="7k48c5lznu9t">
                {link.name}
              </a>)}
            <a href="/#calificar" onClick={event => {
          setIsMobileMenuOpen(false);
          scrollToForm(event);
        }} className="mt-5 mb-2 w-full text-center bg-gold hover:bg-gold-light text-black font-semibold px-6 py-3.5 rounded-lg text-[15px] transition-colors" data-id="element-78" data-mp="f5gdz0m8qic1">
              Agendar consulta
            </a>
          </div>
        </div>}
    </nav>;
}